import { FormExtractorService } from "../../../shared/services/form-extractor.service";
import { LogService } from "../../../shared/services/log.service";
import { Validator } from "../../../shared/services/validator";
import { CTRL_NAME_EXTRACTOR } from "../ctrl.name.extractor";

export class CTRL_500u2 implements Validator {

    public static id = 'CTRL_500u2';
    private message = 'error.ctr_500';


    public LOG: LogService = new LogService(CTRL_500u2);
    public formExtractorService: FormExtractorService = new FormExtractorService();

    
    validate(form: any, map) {

        
        // vérifier si la règle est applicable sur mon formulaire
        const rgs: string[] = CTRL_NAME_EXTRACTOR.getCtrlNames(form, CTRL_500u2.id + "_");

        if (rgs.length > 0) {
            for (var rg of rgs) {
                const ctrl = form.controls[rg];
                const objetPrinCp = ctrl.value.rgCtrls.objetPrinCp;
                const objetPrinCs = ctrl.value.rgCtrls.objetPrinCs;
                const objetCompCp = ctrl.value.rgCtrls.objetCompCp;
                const objetCompCs = ctrl.value.rgCtrls.objetCompCs;

                const controls = this.formExtractorService.getMapControlsIdWithoutStepAndValue(form);
                let controlsNameCpv = [];
                let ids = rg.split("_");
                let numMarche = ids[6];
                let numLot = ids[7];

                const objetPrCsIters = this.formExtractorService.getIndexes(Array.from(controls.keys()), [objetPrinCs.replace('INDEX_500_1', numMarche).split('INDEX_500_2')[0] + numLot, 'SepAtt_classSupplementaire'], '_SepSep_Lot_SepSep_TypeObjCPV_index_');
                const objetSpCpIters = this.formExtractorService.getIndexes(Array.from(controls.keys()), [objetCompCp.replace('INDEX_500_1', numMarche).replace('INDEX_500_2', numLot).split('INDEX_500_3')[0], '_SepAtt_classPrincipale'], '_SepSep_Lot_SepSep_TypeObjCPV_index_');

                controlsNameCpv.push(objetPrinCp.replace('INDEX_500_1', numMarche).replace('INDEX_500_2', numLot));

                for (var i = 1; i <= objetPrCsIters.size; i++) {                
                    controlsNameCpv.push(objetPrinCs.replace('INDEX_500_1', numMarche).replace('INDEX_500_2', numLot).replace('INDEX_500_3', i));
                }

                for (var i = 1; i <= objetSpCpIters.size; i++) {
                    controlsNameCpv.push(objetCompCp.replace('INDEX_500_1', numMarche).replace('INDEX_500_2', numLot).replace('INDEX_500_3', i));

                    const objetSpCsIters = this.formExtractorService.getIndexes(Array.from(controls.keys()), [objetCompCs.replace('INDEX_500_1', numMarche).replace('INDEX_500_2', numLot).split('INDEX_500_3')[0] + i, 'SepAtt_classSupplementaire'], '_SepSep_Lot_SepSep_TypeObjCPV_index_');
                    for(var j = 1; j <= objetSpCsIters.size; j++) {
                        controlsNameCpv.push(objetCompCs.replace('INDEX_500_1', numMarche).replace('INDEX_500_2', numLot).replace('INDEX_500_3', i).replace('INDEX_500_4', j));
                    }
                }
                let valuesCpv = [];
                for (var i = 0; i < controlsNameCpv.length; i++) {
                    if(map.get(controlsNameCpv[i])) {
                        if (Array.isArray(form.controls[map.get(controlsNameCpv[i])].value)) {
                            form.controls[map.get(controlsNameCpv[i])].value.forEach(function(item){
                                valuesCpv.push(item);
                            })
                        } else {
                            valuesCpv.push(form.controls[map.get(controlsNameCpv[i])].value);
                        }
                    }
                }
                if (valuesCpv.filter((item, i, ar) => ar.indexOf(item) === i).length === valuesCpv.length) {
                    form.controls[rg].value = { rgCtrls: ctrl.value.rgCtrls, ctrlValidation: false };
                } else {
                    // placer le message d'erreur
                    form.controls[rg].value = { rgCtrls: ctrl.value.rgCtrls, ctrlValidation: true, validation_message: this.message };
                }
            }
        }
    }
}